// No `.web` here: Expo Router loads this file on native too, and the web screen's
// maplibre-gl crashes native at startup. Metro resolves the platform's screen; web routes via `.web.tsx`.
export { default } from "@src/features/traffic-flow/screens/TrafficFlowScreen";
